import type { PlanConfigExpanded } from "@brookbush/types";

import type { UserResource } from "@clerk/types";

import { isEmployeeUser } from "./membership.lib";
import * as fbq from "~/lib/fpixel";
import * as gtag from "~/lib/gtag";
import { getAmountIndividual } from "~/lib/stripe/helpers";

export const trackPurchasePixelEvent = async (
	user: UserResource,
	planConfig: PlanConfigExpanded,
) => {
	const priceInDollars = getAmountIndividual(planConfig.price!);

	// Do not track employee users, which could be testing the site or developers
	if (isEmployeeUser(user) || process.env.NODE_ENV === "development") return;

	// This is for FB Conversion API
	await fbq.FBConversionAPIEvent({
		event_name: "Purchase",
		custom_data: {
			currency: "USD",
			value: priceInDollars,
		},
		event_id: `${user.id}-${planConfig.priceId}`,
		user_data: {
			first_name: user?.firstName || "",
			last_name: user?.lastName || "",
			email: user?.emailAddresses[0].emailAddress || "",
		},
	});

	// This is for Google Tag Manager
	gtag.event({
		action: "Purchase",
		value: priceInDollars,
	});

	// This is for Google Tag Manager
	gtag.conversionEvent({
		email: user?.emailAddresses[0].emailAddress || "",
		transactionId: `${user?.id}-${planConfig.priceId}`,
		value: priceInDollars,
		conversionType: "PURCHASE",
	});

	// This is for Google Universal Event Tracking
	window.uetq = window.uetq || [];
	window.uetq.push("event", "purchase", {});
};

// I understand this is duplicate code, but pixels are highly sensitive
// and I want to make sure we don't leave a possibility of missing any events
export const trackInitiateCheckoutPixelEvent = async (
	user: UserResource,
	planConfig: PlanConfigExpanded,
) => {
	if (isEmployeeUser(user) || process.env.NODE_ENV === "development") return;

	await fbq.FBConversionAPIEvent({
		event_name: "InitiateCheckout",
		event_id: user.id + planConfig.priceId,
		user_data: {
			first_name: user.firstName || "",
			last_name: user.lastName || "",
			email: user.emailAddresses[0].emailAddress || "",
		},
	});
	gtag.event({
		action: "InitiateCheckout",
	});
	gtag.event({
		action: "begin_checkout",
	});
	gtag.conversionEvent({
		email: user.emailAddresses[0].emailAddress || "",
		transactionId: user.id + planConfig.priceId,
		value: 5,
		conversionType: "INITIATE_CHECKOUT",
	});
	window.uetq = window.uetq || [];
	window.uetq.push("event", "addpayment", {});
};
